import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PromotorCategoryAssignmentModel } from 'src/app/model/promotor-category-assignment.model';

@Injectable({
  providedIn: 'root'
})
export class PromotorCategoryAssignmentService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getAll = () => {
    return this.http.get(`${this.url}/PromotorCategoryAssignment/List`)
      .pipe(map((resp: any) => resp));
  }

  save = (entity: PromotorCategoryAssignmentModel) => {
    return this.http.post(`${this.url}/PromotorCategoryAssignment/SaveUpdate`, entity)
      .pipe(map((resp: any) => resp));
  }

  update = (entity: PromotorCategoryAssignmentModel) => {
    return this.http.post(`${this.url}/PromotorCategoryAssignment/SaveUpdate/${entity.promotorCategoryAssignmentId}`, entity)
      .pipe(map((resp: any) => resp));
  }

  // Historial de asignaciones manuales de un empleado (usado desde el modal de Empleados)
  getByEmployee = (employeeId: string, userName: string) => {
    return this.http.get(`${this.url}/PromotorCategoryAssignment/ByEmployee/${employeeId}/${userName}`)
      .pipe(map((resp: any) => resp));
  }

  // Alta/edición: el backend distingue por si promotorCategoryAssignmentId viene null o con valor
  saveUpdate = (entity: PromotorCategoryAssignmentModel, userName: string) => {
    return this.http.post(`${this.url}/PromotorCategoryAssignment/SaveUpdate/${userName}`, entity)
      .pipe(map((resp: any) => resp));
  }

  // Baja lógica explícita (no DELETE)
  deactivate = (assignmentId: number, userName: string) => {
    return this.http.post(`${this.url}/PromotorCategoryAssignment/Deactivate/${assignmentId}/${userName}`, {})
      .pipe(map((resp: any) => resp));
  }
}
